export const TABS = {
  RECURRENCE: 'recurrence',
  HISTORY: 'history',
};
